import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

export type Filters = {
  makes: Array<{
    name: string;
    parentModels: Array<{
      name: string;
    }>;
  }>;
};

export type CvnaId = {
  filters: Filters & {
    isFreeDelivery?: boolean;
  };
};

export default function useMakeParentModelSearchLink(withFreeDelivery = false) {
  const { make = '', parentModel = '' } = useGetVehicleDetails();
  const filtersObject: CvnaId = {
    filters: {
      makes: [{ name: make, parentModels: [{ name: parentModel }] }]
    }
  };

  if (withFreeDelivery) {
    filtersObject.filters.isFreeDelivery = true;
  }

  return generateSearchLinkFilter(filtersObject);
}
